require([
  'jquery',
  'jquery.ui',
  'wabreakpoint',
  'wanavigation',
  'waoffcanvas',
  'wamodal',
  'waajax',
  'waslider',
  'watabs',
  'waproductbox',
  'wanoticelist',
  'wanotifications',
  'wamessages',
  'waproductfastview',
  'wazoom',
  'wafilter',
  'wavideos',
  'washare',
  'wacountdown',
  'warollcalculator',
  'wanewsletter',
  'wathirdparty',
  'tdnavigation',
  'tdnoticelist',
  'tdwallpaper',
  'tdfilter',
  'tdproducttobasket',
  'tdcheckout',
  'tddropdown',
  'tdfloor',
  'tdsearch',
  'tdreviews',
  'tdmain',
  'tdautosuggest',
  'tdstepmats',
  'tdautotext',
  'tdcrossselling',
  'benefit'
],
function(
  $,
  $ui,
  wabreakpoint,
  wanavigation,
  waoffcanvas,
  wamodal,
  waajax,
  waslider,
  watabs,
  waproductbox,
  wanoticelist,
  wanotifications,
  wamessages,
  waproductfastview,
  wazoom,
  wafilter,
  wavideos,
  washare,
  wacountdown,
  warollcalculator,
  wanewsletter,
  wathirdparty,
  tdnavigation,
  tdnoticelist,
  tdwallpaper,
  tdfilter,
  tdproducttobasket,
  tdcheckout,
  tddropdown,
  tdfloor,
  tdsearch,
  tdreviews,
  tdmain,
  tdautosuggest,
  tdstepmats,
  tdautotext,
  tdcrossselling,
  benefit
) {
  window.isTouchDevice = ('ontouchstart' in window || (navigator.msMaxTouchPoints > 0));
  (!!window.isTouchDevice) ? document.getElementsByTagName('html')[0].setAttribute('data-touch', 1) : '';

	$(document).ready(function($) {
    //Wa Breakpoint Fuction (Global Scope wabreakpoint)
    wabreakpoint.js_getBreakpoint();

    //Wa Slider Init
    waslider.init();

    // Wa Modal
    wamodal.openSelf();
    wamodal.openUrl();
    wamodal.openBtns();
    wamodal.energyLabelModal();
    
    // Wa Navigation Init
    wanavigation.init();
    
    // Wa Offcanvas Init
    waoffcanvas.init();
      
    // Wa Product Box Category
    waproductbox.js_productbox();
    
    // Wa Product Fast View Category
    waproductfastview.js_fastview();

    // Wa Product Zoom
    wazoom.init();

    // Wa Filter
    wafilter.init();

    // Wa Videos
    wavideos.init();
    
    // Native Share
    washare.init();
    
    // Wa Noticelist
    wanoticelist.init();
	  
    //Wa Tabs Init
    watabs.init();

    // Wa Countdown
    wacountdown.init();
    
    // Wa Product Calculator
    warollcalculator.init();
    
    // Wa Newsletter
    wanewsletter.init();
    
    // Wa Third Party
    wathirdparty.init();

    // TD Specific
    tdproducttobasket.init();
    tddropdown.init();
    tdfloor.init();
    tdnavigation.js_buildSubNavigation();
    tdnoticelist.init();
    tdwallpaper.init();
    tdfilter.init();
    tdcheckout.js_checkoutOptions();
    tdcheckout.js_checkoutOptionChange();
    tdproducttobasket.setBasketAnimation();
    tdsearch.init();
    tdreviews.init();
    tdmain.init();
    tdautosuggest.init();
    tdstepmats.init();
    // tdautotext.init();
    tdcrossselling.init();
    benefit.init();

    //oxDropDown
    $('div.dropDown p').oxDropDown();

      // Jquery Plugins  ******************************************* */
      $.fn.hasAttr = function (name) {
        return this.attr(name) !== undefined;
      };
	  
    !window.isTouchDevice ? $('.scroll-container').mCustomScrollbar({axis:"y",theme: "dark-2"}) : '';
  });
});
define("app", function(){});

